/* eslint-disable */
// GENERATED FILE — do not edit. Run `npm run catalog:build` after changing catalog/**.
// Source of truth: catalog/<area>/<ID>.md. `npm run catalog:check` fails when this is stale.
import type { CatalogEntry } from './types';

/** Fingerprint of the catalog sources this file was built from. */
export const CATALOG_HASH = 'b7ef8383eb94f640617a2dbc6abfe138cbc2b234e59389e1316620ed59d1d15b';

export const CATALOG_ENTRIES: readonly CatalogEntry[] =
  [
    {
      "id": "ACC-001",
      "area": "access",
      "job": "Give or change a user's access to a client",
      "description": "Select the client and open the \"User Assignments\" view, which lists who has access to this client and with which role. Type a name in \"Select user\" to search the directory; for a user who is not assigned yet, choose the role in the new row (for example HR or Admin), tick \"Limited\" for restricted access if needed, and save the row. To change an existing user, change the role or flag in their row and save (the arrow next to it undoes unsaved changes); the delete icon removes their access to this client after a confirmation.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "\"User Assignments\" is visible to SuperAdmin and to global, country and company admins (including their read-only variants), not to HR roles. Read-only admins see save and delete disabled.",
      "aliases": [
        "add a user",
        "give access",
        "assign a user to a client",
        "grant access to a company",
        "change a user role",
        "remove a user",
        "revoke access",
        "who has access",
        "add an HR user",
        "user permissions",
        "user assignments"
      ],
      "anchor": "hr-user-assignment-add",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ACC-002",
      "area": "access",
      "job": "Restrict a user's access to certain benefits",
      "description": "Select the client and open the \"Security\" view, a grid of users against benefits. Set each cell to \"View+Edit\" (the default), \"View\" (read only) or \"No Access\" (the benefit and its enrollments are hidden from the user); \"Mark All\" in a user row or a benefit column marks every cell in it, and the next value you pick applies to all marked cells. Click \"Save Changes\" to store all changed cells, or \"Cancel\" to discard them; the \"Limited\" flag in \"User Assignments\" is combined with these settings.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "\"Security\" is visible to admin roles (not their read-only variants) and to HR company admins with user-assignment rights.",
      "aliases": [
        "hide a benefit from a user",
        "read only access to a benefit",
        "no access",
        "limit a user",
        "benefit permissions",
        "implementation permissions",
        "security settings",
        "view only",
        "restrict an HR user",
        "limited access",
        "make a user read only",
        "read only for one benefit"
      ],
      "anchor": "hr-security-cell",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ACC-003",
      "area": "access",
      "job": "Find out why buttons are greyed out for me",
      "description": "Read-only roles see the edit, eligibility and delete buttons greyed out, and changes such as approvals are refused for them. Your role for a client is set by an admin in \"User Assignments\" and decides which pages you see and what you may change; the \"Security\" view can also limit you to \"View\" or \"No Access\" for single benefits. Some actions are reserved: deleting employees and dependents is for SuperAdmin only, \"Bulk Management\" is for admin roles, and bulk enrollment changes and employee tags can only be saved by GrECo users.",
      "roles": [
        "user",
        "hr"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "buttons greyed out",
        "cannot edit",
        "read only",
        "no permission",
        "why is the button disabled",
        "access denied",
        "cannot save",
        "change refused",
        "who can edit",
        "editor rights",
        "missing button",
        "cannot change anything",
        "all buttons are grey"
      ],
      "source_ref": "help:HrPage"
    },
    {
      "id": "CAT-001",
      "area": "catalog",
      "job": "Add a benefit category to the global catalog",
      "description": "On the Admin page, click \"Add Benefit Category\" in the toolbar. Enter the name (required, 2 to 128 characters, unique among the global categories), choose \"Consent Needed\" and \"Is Auto Enrollment\" (they cannot both be Yes) and write the description (required, 2 to 4000 characters); Superadmins can also pick a cover picture with \"Select Image\", and \"Upload\" under \"Document List\" adds files that are uploaded together with the category. Check the name before you click \"Save\", because it cannot be changed later; country admins then add the category to their countries on the Country page.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "A Global admin role that is not read-only; read-only Global admins see the button greyed out.",
      "aliases": [
        "new benefit category",
        "create category",
        "add category",
        "add a benefit type",
        "new benefit in the catalog",
        "create a global benefit",
        "define a new benefit",
        "add a new kind of benefit",
        "new benefit in the global list"
      ],
      "anchor": "admin-add-category",
      "anchor_action": "open",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-002",
      "area": "catalog",
      "job": "Edit a benefit category in the global catalog",
      "description": "On the Admin page, click the Edit icon on the category card (in List View, the Edit icon in the Actions column) to open \"Edit Category\". Change \"Consent Needed\", \"Is Auto Enrollment\", the description or, as a Superadmin, the cover picture, and click \"Save\". The name cannot be changed, because the server rejects a save with a different name, and the edit does not change the country copies that already exist.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "A Global admin role that is not read-only.",
      "aliases": [
        "change a category",
        "update a category",
        "modify a benefit category",
        "edit category description",
        "rename a category",
        "change the category name",
        "edit global category"
      ],
      "anchor": "benefit-card-edit",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-003",
      "area": "catalog",
      "job": "Set whether a benefit category needs consent or auto-enrollment",
      "description": "Open the category with its Edit icon, choose Yes or No for \"Consent Needed\" and \"Is Auto Enrollment\" and click \"Save\"; in List View you can change the two columns directly and then click Save in the row's Actions column. New benefits created under the category start with these values. The two cannot both be Yes: the dialog sets the other one to No, and the server rejects a table row with both set to Yes. Set them on the Admin page for the global category, on the Country page for one country, or on the Company profile for one client.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role that is not read-only.",
      "aliases": [
        "consent needed",
        "auto enrollment",
        "automatic enrollment",
        "require consent for a category",
        "default consent",
        "turn on auto-enrollment",
        "consent default",
        "enroll employees automatically by default"
      ],
      "anchor": "benefit-card-edit",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-004",
      "area": "catalog",
      "job": "Delete a benefit category",
      "description": "Click the bin icon on the category card (in List View, the bin in the Actions column) and confirm. On the Admin page this deletes the global category and its documents, together with every country and client category based on it and the client benefits built on those; on the Country page it removes only that country's category, with the client categories and benefits based on it. The server accepts a category delete only from members of the Global admins group.",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Superadmin, and membership of the Global admins group; the server rejects the delete from anyone else.",
      "aliases": [
        "remove a category",
        "delete category",
        "delete a benefit type",
        "remove a benefit from the catalog",
        "get rid of a category",
        "remove a category from a country"
      ],
      "anchor": "benefit-card-delete",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-005",
      "area": "catalog",
      "job": "Change the cover picture of a benefit category",
      "description": "On the Admin page, click the camera icon on the category card: the image library opens in picking mode, and the camera button next to an image makes it the cover picture and saves the category at once. In the category dialog, \"Select Image\" under \"Choose Cover Picture\" does the same and the x button removes the picture; there the picture is saved when you click \"Save\". A picture that is not in the library yet must first be uploaded with \"Manage Images\".",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Superadmin; other admins see cover pictures read-only, and on the Country page they cannot be changed.",
      "aliases": [
        "category image",
        "change picture",
        "cover image",
        "set the category photo",
        "benefit image",
        "change the thumbnail",
        "remove the cover picture",
        "upload a cover photo"
      ],
      "anchor": "benefit-card-photo",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-006",
      "area": "catalog",
      "job": "Upload or delete images in the image library",
      "description": "On the Admin page, click \"Manage Images\" in the toolbar. \"Upload\" picks one or more files and puts them in a queue: the save icon next to a file uploads it, \"Save All\" (shown when more than one file is queued) uploads them all, the bin removes a file from the queue and \"Clear\" empties the queue; a file whose name already exists in the library is skipped. To delete an image, click its bin icon and confirm; the server keeps an image that is still the cover picture of a category, benefit or package.",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Superadmin; the button is hidden for other roles.",
      "aliases": [
        "image library",
        "manage images",
        "upload pictures",
        "add images",
        "delete an image",
        "picture gallery",
        "upload new cover pictures",
        "remove a picture from the library"
      ],
      "anchor": "admin-manage-images",
      "anchor_action": "open",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-007",
      "area": "catalog",
      "job": "Add documents to a benefit category",
      "description": "Click the documents icon (\"Manage Documents\") on the category card; in List View, click the button in the Documents column, which shows how many documents the category has. In \"Manage Documents\", \"Upload\" picks one or more files, which you then save one by one with the save icon or together with \"Save All\"; saved documents are edited or deleted in the same dialog. Document changes are saved there, separately from the category, and this works the same for the global category on the Admin page and for a country's category on the Country page.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role that is not read-only; read-only roles see the button greyed out.",
      "aliases": [
        "upload documents",
        "category documents",
        "attach a file",
        "add a PDF",
        "manage documents",
        "benefit documents",
        "add attachments",
        "delete a category document"
      ],
      "anchor": "benefit-card-documents",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-008",
      "area": "catalog",
      "job": "Change the order of the benefit cards",
      "description": "In the card view, drag the cards into the order you want, then click \"Save Order\" in the toolbar. The order is saved to your own user settings, so other users keep their own order; on the Country page it is saved separately for each country, and on the Company profile for each company. \"Save Order\" is shown only in the card view and is greyed out while a search is active.",
      "roles": [
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/country",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Card view (Grid View in the settings menu), and an empty search box.",
      "aliases": [
        "reorder cards",
        "sort the benefit cards",
        "rearrange categories",
        "drag and drop cards",
        "move a card",
        "card order",
        "change the category order",
        "save order"
      ],
      "anchor": "benefit-cards-save-order",
      "source_ref": "help:CountryPage"
    },
    {
      "id": "CAT-009",
      "area": "catalog",
      "job": "Add a benefit category to a country",
      "description": "On the Country page, pick the country in \"Select Country\", then click \"Add Benefit Category\" in the toolbar. In \"Category\", pick one of the global categories the country does not have yet; the dialog copies its name, consent and auto-enrollment values, cover picture and description. Change \"Consent Needed\", \"Is Auto Enrollment\" and the description for this country if needed, add files under \"Document List\" with \"Upload\", and click \"Save\".",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/country",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country first; Country admins can pick only the countries assigned to them. The button is greyed out for read-only roles and when the country already has every global category.",
      "aliases": [
        "add a category to a country",
        "offer a benefit in a country",
        "copy a global category to a country",
        "enable a benefit for a country",
        "add benefit for a country",
        "offer the benefit in another country",
        "country catalog",
        "category missing in a country"
      ],
      "anchor": "country-add-category",
      "anchor_action": "open",
      "source_ref": "help:CountryPage"
    },
    {
      "id": "CAT-010",
      "area": "catalog",
      "job": "Set up the benefit categories of a new country",
      "description": "On the Country page, pick a country that has no benefit categories yet in \"Select Country\": the \"Add Benefits for:\" dialog opens by itself and lists every global category. Click a row to tick or untick it in the \"Included\" column, or use \"Select All\" and \"Clear all\", then click \"Save\" to create a country copy of each ticked category. If you close the dialog without saving, the country stays empty; you can still add categories one at a time with \"Add Benefit Category\".",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/country",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Country admins see only the countries assigned to them in Select Country.",
      "aliases": [
        "new country",
        "first time setup of a country",
        "start a country catalog",
        "choose the categories for a country",
        "select all categories for a country",
        "country has no categories",
        "add benefits for a country"
      ],
      "anchor": "subheader-country-select",
      "source_ref": "help:CountryPage"
    },
    {
      "id": "CAT-011",
      "area": "catalog",
      "job": "Change a benefit category for one country only",
      "description": "On the Country page, pick the country and click the Edit icon on the category card; in List View, use the Edit icon in the Actions column, or change the cells and click Save in that row. Change \"Consent Needed\", \"Is Auto Enrollment\" or the description and click \"Save\": the change applies only to this country, and the global category and the other countries do not change. The name stays that of the global category, and cover pictures can be chosen only on the Admin page.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/country",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country first; an admin role that is not read-only.",
      "aliases": [
        "edit a country category",
        "country specific description",
        "change consent for a country",
        "local category settings",
        "edit a category per country",
        "update the country copy",
        "change the description for one country",
        "country specific settings"
      ],
      "anchor": "benefit-card-edit",
      "source_ref": "help:CountryPage"
    },
    {
      "id": "CAT-012",
      "area": "catalog",
      "job": "Open the global benefits analytics report",
      "description": "On the Admin page, click the \"Analytics\" tab next to \"Benefits\": the catalog is replaced by the embedded Power BI report. Move between report pages with the navigation inside the report, and use the refresh button next to the search box to reload it; click \"Benefits\" to return to the catalog.",
      "roles": [
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/admin",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "A Global admin role; read-only Global admins can open the analytics too.",
      "aliases": [
        "analytics",
        "power bi",
        "analytics report",
        "statistics",
        "benefit statistics",
        "charts",
        "global analytics",
        "analytics tab"
      ],
      "anchor": "admin-tab-analytics",
      "source_ref": "help:AdminPage"
    },
    {
      "id": "CAT-013",
      "area": "catalog",
      "job": "Open the analytics report of a country",
      "description": "On the Country page, pick the country in \"Select Country\", then click the \"Analytics\" tab next to \"Benefits\": the catalog is replaced by the embedded Power BI report for that country. Move between report pages with the navigation inside the report.",
      "roles": [
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/country",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country first; Country admins see only the countries assigned to them.",
      "aliases": [
        "country analytics",
        "country report",
        "power bi for a country",
        "statistics for a country",
        "country dashboard",
        "analytics per country"
      ],
      "anchor": "country-tab-analytics",
      "source_ref": "help:CountryPage"
    },
    {
      "id": "CLI-001",
      "area": "clients",
      "job": "Choose the client company to work on",
      "description": "On the Company profile, pick the country in \"Select Country\" first, then type at least one letter of the company name in \"Select Company\" and pick it from the results, shown as \"name (partner number)\". The company's benefit categories appear below; the company stays selected when you come back to the page, and the HR page uses the same company. Changing the country clears the selected company, because the company search works within one country.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "The country list shows only the countries your role gives you access to.",
      "aliases": [
        "select a client",
        "pick a company",
        "find a client",
        "switch client",
        "change company",
        "search for a company",
        "open a client",
        "select customer",
        "company not in the list",
        "switch to another company"
      ],
      "anchor": "subheader-client-select",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-002",
      "area": "clients",
      "job": "Set up the benefit categories of a new client",
      "description": "On the Company profile, select the country and then a company that has no benefit categories in that country yet: the \"Add Benefits for\" dialog opens by itself and lists the benefit categories defined for the country. Tick \"Included\" for each category the client should offer (\"Select All\" ticks every one, \"Clear all\" unticks them), then click \"Save\" to create the client's categories as copies linked to the country categories. Closing the dialog with X leaves the client without categories; select the company again to reopen it, and add more categories later with \"Add Benefit Category\".",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "The country needs benefit categories first; they are set up on the Country page.",
      "aliases": [
        "new client setup",
        "onboard a client",
        "first time setup of a company",
        "choose the benefits a client offers",
        "add benefits for a company",
        "start with a new client",
        "client has no categories"
      ],
      "anchor": "subheader-client-select",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-003",
      "area": "clients",
      "job": "Add a benefit category to a client",
      "description": "On the Company profile, select the country and the company, then click \"Add Benefit Category\" in the toolbar. In \"Category\", pick one of the country's categories that the client does not have yet; its name, consent and auto-enrollment settings, picture and description are copied into the form. Adjust \"Consent Needed\", \"Is Auto Enrollment\" and the description (required, 2 to 4000 characters) for this client, add files with \"Upload\" if needed, and click \"Save\"; the new category appears as a card with zero implementations.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country and the company first; only admin roles can use the button. The toolbar appears once the company has at least one category; a company with none gets the first-setup dialog instead.",
      "aliases": [
        "add a benefit to a client",
        "offer a new benefit to a company",
        "add a category to a company",
        "new benefit category for a client",
        "give a client another benefit",
        "category missing for a client"
      ],
      "anchor": "company-add-category",
      "anchor_action": "open",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-004",
      "area": "clients",
      "job": "Edit a client's settings, logo and salary deduction consent",
      "description": "On the Company profile, click the client name with the logo in the toolbar and choose \"Edit\". In \"Edit Client\", set \"Sic Code\" (the industry classification, required), the logo or cover picture with \"Choose Company Cover Picture\", and the \"Salary Deduction Consent\" document that employees get when they enroll in a package paid through salary deduction. \"Client Name\" comes from GrECo's client records and cannot be changed in HBH; \"Save\" is enabled once you change something.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country and the company first; the client name appears in the toolbar once the company has at least one benefit category. Read-only roles can open the dialog but cannot save.",
      "aliases": [
        "edit client",
        "client settings",
        "change the company logo",
        "industry code",
        "SIC code",
        "salary deduction consent",
        "company cover picture",
        "update client details",
        "rename a client"
      ],
      "anchor": "edit-client-menu",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-005",
      "area": "clients",
      "job": "Change the invitation e-mail and welcome texts for employees",
      "description": "On the Company profile, click the client name in the toolbar and choose \"Edit\". In \"Edit Client\", \"Email Invitation Text\" is the body of the invitation e-mail HBH sends to the client's employees and \"Message To Employees\" is the greeting at the top of the employee app (both required, 2 to 4000 characters); \"Welcome Page Content\" is the formatted home page of the employee app, which can include pictures and has a preview button. In the e-mail editor, \"Clear\" empties the text and, while it is empty, \"Default\" brings back the saved text; click \"Save\" to keep your changes.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country and the company first; the client name appears in the toolbar once the company has at least one benefit category. Read-only roles can open the dialog but cannot save.",
      "aliases": [
        "invitation email",
        "invite email text",
        "welcome page",
        "welcome message",
        "message to employees",
        "employee greeting",
        "email template for employees",
        "home page of the employee app",
        "change the invitation"
      ],
      "anchor": "edit-client-menu",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-006",
      "area": "clients",
      "job": "Upload documents that belong to the whole client",
      "description": "On the Company profile, click the client name in the toolbar, choose \"Edit\", and in \"Edit Client\" click \"Add Documents\" (\"Manage Documents\" once the client has some), for documents that belong to the client as a whole rather than to one benefit. In the documents dialog, \"Upload\" picks one or more files; the eye icon on a waiting file hides it from employees or shows it, and you save each file with its save icon or all of them with \"Save All\". Changes there are saved immediately, not with the \"Save\" of the client dialog; for one benefit category, use the documents icon on its card instead.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country and the company first; the client name appears in the toolbar once the company has at least one benefit category.",
      "aliases": [
        "client documents",
        "company documents",
        "upload a document for a client",
        "general documents for employees",
        "documents for the whole company",
        "client level documents",
        "hide a document from employees",
        "attach a file to a client"
      ],
      "anchor": "edit-client-menu",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-007",
      "area": "clients",
      "job": "Delete a client from HBH",
      "description": "On the Company profile, select the country and the company, click the client name in the toolbar, choose \"Delete\" and confirm. This deletes the client with its benefit categories, implementations, packages, enrollments, employees, documents and user assignments. \"Delete\" is active only for SuperAdmin, and the server carries out deletes only for GrECo global administrators.",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "SuperAdmin; the server carries out the delete only for GrECo global administrators.",
      "aliases": [
        "remove a client",
        "delete a company",
        "remove a company from HBH",
        "offboard a client",
        "delete customer",
        "client no longer with us"
      ],
      "anchor": "edit-client-menu",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-008",
      "area": "clients",
      "job": "Open the analytics report of a client",
      "description": "On the Company profile, select the country and the company, then click the \"Analytics\" tab next to \"Benefits\": it shows the Power BI report for the selected company and country. Use the refresh button next to the country field to reload it, and \"Benefits\" to return to the categories.",
      "roles": [
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country and the company first; the tabs appear once the company has at least one benefit category.",
      "aliases": [
        "client analytics",
        "company report",
        "power bi for a client",
        "client statistics",
        "company dashboard",
        "analytics for a company",
        "company analytics",
        "analytics on the company profile"
      ],
      "anchor": "company-tab-analytics",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "CLI-009",
      "area": "clients",
      "job": "Change a benefit category for one client only",
      "description": "On the Company profile, select the country and the company, then click the Edit icon on the category card; in List View, use the edit icon in the Actions column, or change the cells and then save the row there. Change \"Consent Needed\", \"Is Auto Enrollment\" or the description (required, 2 to 4000 characters) and click \"Save\": new implementations of the category start with these values. The name is inherited from the country category and cannot be changed here.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the country and the company first; an admin role.",
      "aliases": [
        "edit a client category",
        "client specific description",
        "change consent for a client",
        "edit a category for a company",
        "category settings for one client",
        "change the category description for a client",
        "consent default for one client"
      ],
      "anchor": "benefit-card-edit",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "EMP-001",
      "area": "employees",
      "job": "Add an employee",
      "description": "On the HR page, select the client, open the \"Employees\" view and click \"Add Employee\" in the toolbar. Fill in first and last name, email, \"Mobile Phone Number\", \"Employment Date\" and \"Date of Birth\" (all required) and save; the email becomes the employee's login for the employee app and receives the sign-up invitation. In the same form you can attach files in the \"Document List\" and add family members with \"Add Dependent\" under \"Dependent Coverages\".",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client in \"Select Company\" at the top of the HR page first. Read-only roles see \"Add Employee\" disabled.",
      "aliases": [
        "new employee",
        "create employee",
        "add a person",
        "register an employee",
        "add a new hire",
        "onboard an employee",
        "new staff member",
        "enter a new employee",
        "hired someone new",
        "new colleague joined",
        "put a new employee in the system"
      ],
      "anchor": "hr-add-employee",
      "anchor_action": "open",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-002",
      "area": "employees",
      "job": "Edit an employee's details",
      "description": "In the \"Employees\" view, click the edit (pencil) icon in the employee's row; the form shows all personal data, documents and dependents. Change the fields and click Save; first and last name, email, mobile phone, employment date and date of birth stay required. Editing the email later changes the contact address only, not the employee's login, and \"Salary\" and the comment are never shown to the employee.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. Read-only roles see the edit icon disabled.",
      "aliases": [
        "change employee data",
        "update employee information",
        "correct an employee record",
        "update phone number",
        "change employee email",
        "edit personal data",
        "modify employee",
        "update salary",
        "fix an employee name",
        "change employment date",
        "change the last name",
        "correct a surname",
        "fix a typo in a name"
      ],
      "anchor": "hr-employee-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-003",
      "area": "employees",
      "job": "Record that an employee left the company",
      "description": "In the \"Employees\" view, open the employee with the edit (pencil) icon, set the \"Date of Exit\" and save. The system then marks the employee as inactive (\"Is Inactive\" is set only by the system); clearing the date makes them active again. Afterwards, check the employee's enrollments and cancel every one that should end with the employment (\"Edit Enrollment\", \"Cancelation Date\").",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. Read-only roles see the edit icon disabled.",
      "aliases": [
        "employee leaves",
        "terminate an employee",
        "offboard an employee",
        "end employment",
        "employee resigned",
        "deactivate an employee",
        "mark employee inactive",
        "date of exit",
        "exit date",
        "employee is leaving",
        "remove an employee who left",
        "leaver",
        "set the exit date"
      ],
      "anchor": "hr-employee-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-004",
      "area": "employees",
      "job": "Delete an employee",
      "description": "Only SuperAdmin can delete an employee: click the delete icon in the employee's row in the \"Employees\" view and confirm. This removes the employee together with their enrollments. When someone leaves the company, set a \"Date of Exit\" in their form instead; that is the normal way to end employment.",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. Only SuperAdmin sees the delete button.",
      "aliases": [
        "remove an employee",
        "erase an employee",
        "delete employee record",
        "remove a person from the list",
        "employee added by mistake",
        "permanently delete an employee",
        "duplicate employee"
      ],
      "anchor": "hr-employee-delete",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-005",
      "area": "employees",
      "job": "Add or change an employee's dependents",
      "description": "In the \"Employees\" view, open the employee with the edit (pencil) icon, click \"Manage Dependents\" and then \"Add Dependent\"; choose the dependent type (for example spouse or child), enter first name, last name and date of birth, and click that dependent's own Save. To change an existing dependent, click the employee's name to expand the row and use the edit icon on the dependent line, or change it in \"Manage Dependents\". Deleting a saved dependent is for SuperAdmin only and also removes the dependent's enrollments.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. Read-only roles see the edit icons disabled.",
      "aliases": [
        "add a spouse",
        "add a child",
        "add a family member",
        "add a dependant",
        "add dependants",
        "edit a dependent",
        "remove a dependent",
        "add a partner",
        "family members of an employee",
        "manage dependents",
        "co-insured person",
        "add a wife",
        "add a husband",
        "employee got married",
        "add a newborn baby"
      ],
      "anchor": "hr-employee-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-006",
      "area": "employees",
      "job": "Upload or manage an employee's documents",
      "description": "In the \"Employees\" view, open the employee with the edit (pencil) icon and click \"Manage Documents\" (\"Add Documents\" when there are none). There you upload, rename, hide from the employee or delete files, and the changes are saved immediately; the button is yellow when the employee recently uploaded a document. When you add a new employee, upload the files into the \"Document List\" of the form; the eye icon on each file decides whether the employee can see it.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. Read-only roles see the edit icon disabled.",
      "aliases": [
        "attach a file to an employee",
        "upload employee documents",
        "add a contract",
        "employee attachments",
        "hide a document from the employee",
        "delete an employee document",
        "documents the employee uploaded",
        "employee files"
      ],
      "anchor": "hr-employee-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-007",
      "area": "employees",
      "job": "Resend the employee app invitation",
      "description": "In the \"Employees\" view, tick the employees in the first column and click \"Resend Invitations\" above the table; the sign-up email goes again to each selected employee's login address. For one person, select their row and click the \"Resend Invitation\" icon in it. Both stay disabled until at least one employee is selected.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view.",
      "aliases": [
        "send the invitation again",
        "employee did not get the invitation",
        "resend welcome email",
        "invite employees to the app",
        "resend sign-up email",
        "send login email",
        "bulk invite",
        "invitation email lost"
      ],
      "anchor": "hr-resend-invitations",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-008",
      "area": "employees",
      "job": "Import employees from an Excel file",
      "description": "In the \"Employees\" view, open \"Actions\" in the toolbar and choose \"Generate Import Template\" to download an Excel file prepared for this client, with a column group per package where each person can be marked \"Eligible\" or \"Enrolled\". Fill it in, choose \"Actions\" › \"Import From Template\", drop the file into the dialog, leave \"Send Invitation Mail\" ticked if newly created employees should get the sign-up email, and click \"Import\". Employees and dependents are created or updated row by row with the marked eligibilities and enrollments; you receive a result report by email, and the import with its report is listed in \"Action History\".",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" or \"Bulk Management\" view. Read-only roles see \"Import From Template\" disabled.",
      "aliases": [
        "upload employees",
        "bulk upload employees",
        "excel import",
        "import template",
        "download the import template",
        "upload a spreadsheet",
        "mass import",
        "load the employee list",
        "add many employees at once",
        "import file"
      ],
      "anchor": "hr-import-template",
      "anchor_surface": "hr-actions-menu",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-009",
      "area": "employees",
      "job": "Find an employee",
      "description": "Open the \"Employees\" view and type in the search box at the top of the page; the table filters by first and last name as you type, and the counter next to the box shows how many employees match. Email addresses are not searched. Picking another client clears the search.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view.",
      "aliases": [
        "search for an employee",
        "look up an employee",
        "find a person",
        "search by name",
        "where is my employee",
        "filter employees",
        "employee not in the list",
        "search by email",
        "employee search"
      ],
      "anchor": "subheader-search",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-010",
      "area": "employees",
      "job": "Understand the icons next to an employee's name",
      "description": "In the \"Employees\" view, a red bell in front of a name means the record needs attention, a green shield means GrECo's sensitive-data consent was given, and the avatar dot shows whether the employee has signed up to the employee app (grey when inactive). A yellow edit icon means the employee changed data or uploaded a document in the employee app. The \"Dependents\" and \"Enrollments\" columns count the person's dependents and own packages; click the name to expand the row and see them (only rows with enrollments or dependents expand).",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view.",
      "aliases": [
        "what does the red bell mean",
        "green shield icon",
        "grey avatar",
        "has the employee signed up",
        "has the employee registered",
        "yellow pencil",
        "icons in the employee table",
        "employee status icons",
        "consent shield",
        "expand an employee"
      ],
      "anchor": "hr-employee-name",
      "source_ref": "help:HrPage"
    },
    {
      "id": "EMP-011",
      "area": "employees",
      "job": "Confirm data an employee changed in the employee app",
      "description": "Click the bell on the HR page to open the Needs Attention list; the edit icon turns yellow on rows where the employee changed profile data or uploaded a document in the employee app. The icon opens the employee form with the changed fields highlighted in yellow: click \"Confirm\" to accept them, or correct the data and click Save. For dependents, expand the row and use the dependent's edit icon (green for a dependent the employee added, yellow for changed data) and save the form; each confirmed item leaves the list.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr/needs-attention",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Needs edit rights; read-only users see the edit icon disabled.",
      "aliases": [
        "yellow fields",
        "employee updated their profile",
        "approve profile changes",
        "accept changes from the employee portal",
        "employee changed data",
        "review employee changes",
        "confirm a new dependent",
        "employee added a dependent",
        "highlighted fields",
        "yellow edit icon"
      ],
      "anchor": "hr-employee-edit",
      "source_ref": "help:HrNeedsAttentionPage"
    },
    {
      "id": "EMP-012",
      "area": "employees",
      "job": "Add or remove employee tags",
      "description": "Open the \"Bulk Management\" view, select the employees in the left tree, then choose \"Manage Tags\" › \"Add Tags\" or \"Remove Tags\". Pick tags from \"Existing tags\" or type a new one (up to 25 characters) and click \"Add New Tag\", then click \"Add Employee Tags\" or \"Remove Employee Tags\". \"Manage Tags\" › \"Toggle Tags\" shows each employee's tags in the tree, and the tag filter above it (pick a tag, click \"Assign\") shows only the employees that carry it.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open \"Bulk Management\" (admin roles only). \"Add Tags\" and \"Remove Tags\" stay disabled until an employee (not only a dependent) is selected. Tags can only be saved by GrECo users; the server rejects these requests from client accounts.",
      "aliases": [
        "tag employees",
        "label employees",
        "group employees",
        "employee tags",
        "filter by tag",
        "remove a tag",
        "create a tag",
        "categorise employees",
        "mark employees with a tag"
      ],
      "anchor": "hr-bulk-manage-tags",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-001",
      "area": "enrollments",
      "job": "Make an employee eligible for a package",
      "description": "In the \"Employees\" view, click the \"Manage Package Eligibility\" icon in the employee's row (or on a dependent's line, for a dependent) to open \"Add Package\", and choose the package. The dates and payment terms are filled in from the package rules and the employment date; you can move the eligibility date within the suggested range, and \"Cancellation Possibility\" is the first date the person may cancel. Tick \"Is Auto Enrollment\" to enroll the person automatically, or adjust \"Requires Enrollment Approval\" and \"Requires Cancellation Approval\", then save; the person can now enroll in the employee app.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. Set the employee's \"Employment Date\" first, because the eligibility dates are calculated from it. Read-only roles see the icon disabled.",
      "aliases": [
        "grant eligibility",
        "give access to a benefit",
        "assign a package",
        "add a package to an employee",
        "offer a benefit",
        "add a benefit to an employee",
        "entitle an employee to a package",
        "eligible from date",
        "add an employee to a benefit",
        "require approval for enrollment",
        "give an employee access to a package"
      ],
      "anchor": "hr-employee-eligibility",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-002",
      "area": "enrollments",
      "job": "Enroll an employee in a package",
      "description": "The person must be eligible for the package first. To enroll them yourself, click their name in the \"Employees\" view to expand the row, click \"Edit Enrollment\" (note icon) on the package line, set the \"Enrollment Date\" and save; clearing that date later turns the enrollment back into an eligibility. Alternatively, tick \"Is Auto Enrollment\" when you grant the eligibility, or let the employee enroll in the employee app.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page, open the \"Employees\" view and click the employee's name to expand the row. Read-only roles see \"Edit Enrollment\" disabled.",
      "aliases": [
        "sign up an employee",
        "enrol",
        "register for a benefit",
        "start a benefit",
        "put an employee on a plan",
        "set the enrollment date",
        "sign an employee up for a package",
        "join a package",
        "enroll on behalf of an employee",
        "enrolment"
      ],
      "anchor": "hr-enrollment-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-003",
      "area": "enrollments",
      "job": "Change an enrollment's dates or payment terms",
      "description": "Click the employee's name in the \"Employees\" view to expand the row, click \"Edit Enrollment\" (note icon) on the package line, and change the eligibility, enrollment or cancellation dates, the approval flags or the payment terms (Payment Method, Payment Type, \"Premium/Cost\"). To split the cost, enter the company share; the employee share is filled in automatically, and both must add up to 100 with \"Value Type\" set to percentage, otherwise to the premium. Save; if a red age-limit notice is shown, turn on the switch under it first.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page, open the \"Employees\" view and click the employee's name to expand the row. Read-only roles see \"Edit Enrollment\" disabled.",
      "aliases": [
        "change the enrollment date",
        "correct an enrollment",
        "edit benefit dates",
        "change the premium for an employee",
        "company pays part",
        "employer contribution",
        "employee contribution",
        "change the payment method",
        "cost split",
        "change who pays",
        "edit enrollment",
        "company pays a percentage of the premium",
        "company share",
        "move the start date of an enrollment"
      ],
      "anchor": "hr-enrollment-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-004",
      "area": "enrollments",
      "job": "Cancel an employee's enrollment",
      "description": "Click the employee's name in the \"Employees\" view to expand the row, click \"Edit Enrollment\" (note icon) on the package line, set the \"Cancelation Date\" when the enrollment ends, explain why in \"Reason For Cancellation\" and save. The line turns red from that date. Do not use the delete icon for this, it is only for entries made by mistake; to cancel many people at once, use \"Bulk Management\".",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page, open the \"Employees\" view and click the employee's name to expand the row. Read-only roles see \"Edit Enrollment\" disabled.",
      "aliases": [
        "end a benefit",
        "stop an enrollment",
        "unenroll",
        "opt out",
        "terminate a package",
        "remove from a plan",
        "cancellation date",
        "employee wants out of the plan",
        "end coverage",
        "stop the insurance for an employee"
      ],
      "anchor": "hr-enrollment-edit",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-005",
      "area": "enrollments",
      "job": "Approve or reject an enrollment or cancellation request",
      "description": "Open the Needs Attention list with the bell on the HR page and click the employee's row to expand it; a dashed green border marks an enrollment and a dashed red border a cancellation waiting for approval. Check the attached consent documents with the document button, then click the green button (\"Approve Enrollment\" or \"Approve Cancellation\") and confirm the \"Date of Approval\" (for an enrollment it becomes the enrollment date), or click the red button and enter a \"Rejection Comment\". Rejecting an enrollment removes its enrollment date (for an upgrade the previous package is restored); rejecting a cancellation removes the cancellation date, so the enrollment continues.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr/needs-attention",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Needs edit rights; with a read-only role the change is refused. The same buttons appear on the package lines in the \"Employees\" view of the HR page.",
      "aliases": [
        "pending approval",
        "approve an enrollment",
        "reject an enrollment",
        "approve a cancellation",
        "reject a cancellation",
        "accept a request",
        "decline a request",
        "enrollment waiting for approval",
        "confirm an enrollment request",
        "dashed border",
        "rejection comment"
      ],
      "anchor": "hr-enrollment-approve",
      "source_ref": "help:HrNeedsAttentionPage"
    },
    {
      "id": "ENR-006",
      "area": "enrollments",
      "job": "Delete an eligibility or enrollment made by mistake",
      "description": "Click the employee's name in the \"Employees\" view to expand the row, click the delete icon on the package line and confirm; the eligibility or enrollment is removed together with its documents. Use this only for entries made by mistake: to end a running enrollment, set a \"Cancelation Date\" in \"Edit Enrollment\" instead.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page, open the \"Employees\" view and click the employee's name to expand the row. Read-only roles see the delete icon disabled.",
      "aliases": [
        "remove an eligibility",
        "delete a package from an employee",
        "undo an eligibility",
        "wrong package assigned",
        "delete an enrollment",
        "delete a benefit line",
        "revoke eligibility",
        "package added by mistake",
        "assigned the wrong package"
      ],
      "anchor": "hr-enrollment-delete",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-007",
      "area": "enrollments",
      "job": "Fix an age-limit warning on an enrollment",
      "description": "A red calendar icon on a package line means the person's age is outside the package's age limits; hover it to see the age and the limits. Correct the date of birth in the person's form (edit icon) or the package. When you save an enrollment or eligibility for a person outside the limits, a red notice keeps Save disabled until you turn on the switch under it; the line stays in the Needs Attention list for as long as the person is outside the limits.",
      "roles": [
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr/needs-attention",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Expand the employee's row (in the Needs Attention list or in the \"Employees\" view of the HR page) to see the package lines.",
      "aliases": [
        "red calendar icon",
        "age limit",
        "too old for the package",
        "child too old",
        "age warning",
        "outside the age limits",
        "age restriction",
        "dependent over the age limit",
        "age notice"
      ],
      "anchor": "hr-enrollment-age-warning",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-008",
      "area": "enrollments",
      "job": "Understand the colours of an enrollment line",
      "description": "Click an employee's name in the \"Employees\" view to see their package lines. A light background means eligible only, green enrolled (fading in while the start is in the future), red cancelled and dark grey a package that has ended; a dashed green border marks an enrollment and a dashed red border a cancellation waiting for approval. Each line shows the policy period, \"Eligible From\" and, once set, the enrollment and cancellation dates; a red list icon marks a rejected request, and hovering it shows the rejection comment.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page, open the \"Employees\" view and click the employee's name to expand the row.",
      "aliases": [
        "what does green mean",
        "red line",
        "enrollment status",
        "eligible or enrolled",
        "dashed border",
        "grey package",
        "status colours",
        "is the employee enrolled",
        "why was the request rejected",
        "legend",
        "colour meaning"
      ],
      "anchor": "hr-enrollment-row",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-009",
      "area": "enrollments",
      "job": "See what needs my attention",
      "description": "Click the bell button on the HR page to open the Needs Attention list; the red number on it counts open items, not employees. The list collects profile data and documents changed in the employee app, new or changed dependents, enrollments and cancellations waiting for approval, and enrollments that break a package's age limits, with one row per employee (and a company column when no company is selected at the top). Click a row to expand it and act on each item; an item leaves the list once it is handled, while an age-limit warning stays as long as the person is outside the limits.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr/needs-attention",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "You see only companies you have access to; items from benefits where your access is set to no permission are left out.",
      "aliases": [
        "needs attention",
        "notifications",
        "bell icon",
        "pending items",
        "to-do list",
        "open tasks",
        "what is waiting for me",
        "red badge",
        "inbox",
        "items to review",
        "open requests"
      ],
      "anchor": "hr-needs-attention-column-name",
      "source_ref": "help:HrNeedsAttentionPage"
    },
    {
      "id": "ENR-010",
      "area": "enrollments",
      "job": "Make many people eligible at once",
      "description": "In \"Bulk Management\", select the people in the left tree (or use \"Select\" › \"Select All\") and tick the packages in the right tree, then choose \"Bulk Actions\" › \"Make Eligible\". Tick \"Is Auto Eligibility\" to have the dates calculated per person from the package rules, or enter the eligibility date, end date and cancellation possibility for everyone; \"Is Auto Enrollment\" marks the new eligibilities for automatic enrollment. Click \"Make Eligible\", then \"Show results\" for the per-person report, which is also kept in \"Action History\"; people who are already eligible are skipped.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open \"Bulk Management\" (admin roles only). \"Bulk Actions\" appears once a package is ticked. Bulk enrollment changes can only be saved by GrECo users; the server rejects these requests from client accounts.",
      "aliases": [
        "bulk eligibility",
        "make everyone eligible",
        "mass eligibility",
        "give all employees a package",
        "add a package to many employees",
        "all employees eligible for a new benefit",
        "bulk assign a package",
        "whole company eligible"
      ],
      "anchor": "hr-bulk-actions",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-011",
      "area": "enrollments",
      "job": "Enroll many people at once",
      "description": "In \"Bulk Management\", select the people in the left tree and tick the packages in the right tree, then choose \"Bulk Actions\" › \"Enroll\". Enter the enrollment date for everyone selected who is eligible but not yet enrolled, or tick \"Is Auto Enrollment\" to leave the date empty and mark the enrollments as automatic. Click \"Enroll\", then \"Show results\" for the per-person report, which is also kept in \"Action History\".",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open \"Bulk Management\" (admin roles only). The people must be eligible for the package, and \"Bulk Actions\" appears once a package is ticked. Bulk enrollment changes can only be saved by GrECo users; the server rejects these requests from client accounts.",
      "aliases": [
        "bulk enroll",
        "mass enrollment",
        "enroll everyone",
        "enroll all employees",
        "enroll a group",
        "bulk enrolment",
        "enroll many employees in a package"
      ],
      "anchor": "hr-bulk-actions",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-012",
      "area": "enrollments",
      "job": "Cancel many enrollments at once",
      "description": "In \"Bulk Management\", select the people in the left tree and tick the package in the right tree, then open that package's \"More options\" menu and choose \"Cancel Enrollments\" (or \"Cancel Enrollment\" on one person's line under the package). Enter the cancellation date and the reason for cancellation; both are required and apply to every enrolled person in the selection. Run it, then click \"Show results\" for the per-person report, which is also kept in \"Action History\".",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open \"Bulk Management\" (admin roles only). Bulk enrollment changes can only be saved by GrECo users; the server rejects these requests from client accounts.",
      "aliases": [
        "bulk cancel",
        "cancel everyone",
        "mass cancellation",
        "end a package for all employees",
        "cancel all enrollments",
        "stop a benefit for a group",
        "terminate enrollments in bulk"
      ],
      "anchor": "hr-bulk-benefit-actions",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-013",
      "area": "enrollments",
      "job": "Remove eligibilities or enrollments in bulk",
      "description": "In \"Bulk Management\", select the people in the left tree and tick the packages in the right tree, then choose \"Bulk Actions\" › \"Remove Eligibilities\" or \"Remove Enrollments\". \"Remove Eligibilities\" deletes eligibilities that have no enrollment yet; \"Remove Enrollments\" only clears the enrollment date and keeps the eligibility. Click \"Apply\", then \"Show results\" for the report.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open \"Bulk Management\" (admin roles only). \"Bulk Actions\" appears once a package is ticked. Bulk enrollment changes can only be saved by GrECo users; the server rejects these requests from client accounts.",
      "aliases": [
        "bulk remove eligibility",
        "undo a bulk enrollment",
        "remove a package from many employees",
        "clear enrollment dates",
        "mass delete eligibilities",
        "revert enrollments",
        "remove eligibilities"
      ],
      "anchor": "hr-bulk-actions",
      "source_ref": "help:HrPage"
    },
    {
      "id": "ENR-014",
      "area": "enrollments",
      "job": "See who is enrolled in one package",
      "description": "On the HR page, open the \"Benefits\" view in card view (the default) and double-click a benefit's card picture to open its packages, then double-click a package's card picture to open the employees of that package. The page lists the employees and dependents with an eligibility or enrollment in this package, with their lines and status colours, and you can approve, reject, edit or grant eligibility for this package there. \"Only Elgible/Enrolled\" is on by default; turn it off to list every employee of the company, for example to make someone eligible.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page first. Turn \"Only Active\" off to see enrollments in a benefit that has ended.",
      "aliases": [
        "who is in this package",
        "list of enrolled employees",
        "package members",
        "employees per package",
        "who has this benefit",
        "enrolled people in a plan",
        "package participants",
        "open package employees",
        "who is enrolled in a package",
        "enrolled employees of a package",
        "who is insured under a package",
        "list of insured people",
        "who is covered by this insurance"
      ],
      "anchor": "hr-only-enrolled",
      "anchor_route": "/hr/employees/:packageId/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:HrPackageEmployeesPage"
    },
    {
      "id": "GEN-001",
      "area": "general",
      "job": "Open the page guide for this screen",
      "description": "Click the \"?\" in the header, just before the notifications bell. The \"Page guide\" panel opens on the \"This page\" tab with the guide for the page you are on: every button and field, dialog fields included, grouped by section, with a search box at the top and \"Good to know\" tips at the end. The target icon on an entry shows you where that control is on the page, and the \"Ask\" tab next to \"This page\" answers \"where do I…\" questions about any screen of the app.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "help",
        "open help",
        "page help",
        "user guide",
        "in-app guide",
        "help panel",
        "how does this page work",
        "what can I do on this page",
        "question mark button",
        "instructions for this screen"
      ],
      "anchor": "app-help-launcher",
      "source_ref": "src/help/README.md"
    },
    {
      "id": "GEN-002",
      "area": "general",
      "job": "Take a guided tour of the page",
      "description": "Open the page guide with the \"?\" in the header and click \"Show me around\". The tour highlights the controls that are on screen now one by one, or only the fields of the open dialog when a dialog is open; move with \"Next\" and \"Back\" or the arrow keys, and click the step counter to jump to any step. Press Esc, or \"Done\" on the last step, to end the tour. The play icon on an entry in the guide starts the tour at that control.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "tour",
        "guided tour",
        "walkthrough",
        "show me around",
        "tutorial",
        "onboarding tour",
        "walk me through the page",
        "step by step introduction to the screen"
      ],
      "anchor": "app-help-launcher",
      "source_ref": "src/help/README.md"
    },
    {
      "id": "GEN-003",
      "area": "general",
      "job": "Find out what a button or field does",
      "description": "Open the page guide with the \"?\" in the header and click \"Point at a field\". The page becomes inert and an outline follows your pointer; click any control to read its entry from the guide, and the click never presses the control itself. Press Esc, or the X in the banner, to leave. A running tour offers the same \"Point at a field\" button on its card.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "what does this button do",
        "what is this field",
        "point at a field",
        "explain a field",
        "meaning of a field",
        "help for one control",
        "what does this icon mean",
        "what is this icon",
        "field description"
      ],
      "anchor": "app-help-launcher",
      "source_ref": "src/help/README.md"
    },
    {
      "id": "GEN-004",
      "area": "general",
      "job": "Switch between list view and grid view",
      "description": "Open the settings menu with the gear icon in the header and, under \"View Mode\", click the list icon (\"List View\", a table) or the grid icon (\"Grid View\", cards). The choice is saved for your user and applies to every page with benefit lists: categories, implementations and packages. Some actions exist in only one of them: \"Save Order\" (dragging cards) in the grid view, and changing values directly in a table row in the list view.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "table view",
        "card view",
        "list view",
        "grid view",
        "show as a table",
        "show as cards",
        "change the layout",
        "view mode",
        "switch to table",
        "cards instead of a table"
      ],
      "source_ref": "help:HrPage"
    },
    {
      "id": "GEN-005",
      "area": "general",
      "job": "Change the language of the app",
      "description": "Open the settings menu with the gear icon in the header; the current language is shown at the top of it. Click it and pick another language from the list: the app switches at once and keeps your choice in your user settings. Global admins see every language, other users the languages of their countries plus English and German. The page guides and these answers are in English only for now.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "language",
        "switch language",
        "change to German",
        "translate the app",
        "app in English",
        "interface language",
        "language settings",
        "different language"
      ],
      "source_ref": "src/components/GrecoHeader/GrecoPanel/SettingsMenu/SettingsMenu.tsx"
    },
    {
      "id": "GEN-006",
      "area": "general",
      "job": "Go to another page of the app",
      "description": "Click the grid icon at the far left of the header (\"Navigation\") to open the navigation panel, then pick Admin, Country, Company or HR; \"Company\" opens the Company profile. The panel lists only the pages your role allows: Country admins do not see Admin, client administrators see Company and HR, and HR users see only HR.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "navigation",
        "main menu",
        "switch page",
        "change page",
        "open the admin page",
        "go to company profile",
        "open the HR page",
        "go to the HR page",
        "get to another page",
        "go to the country page",
        "open the country page",
        "open the company page",
        "find a page",
        "app menu"
      ],
      "source_ref": "src/components/Navigation/NavigationContent.tsx"
    },
    {
      "id": "GEN-007",
      "area": "general",
      "job": "Reload the data on a page",
      "description": "Click the circular-arrow button in the bar below the header, next to the search box or the country and company fields. It fetches fresh data for the page or view you are on without reloading the whole app, for example after a colleague or the employee app has changed something; on an Analytics tab it reloads the report instead. On the Company profile it stays disabled until a country and a company are selected.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "refresh",
        "reload",
        "refresh button",
        "update the data",
        "data is not up to date",
        "see the latest changes",
        "fetch again",
        "changes do not show"
      ],
      "anchor": "subheader-refresh",
      "source_ref": "help:HrPage"
    },
    {
      "id": "GEN-008",
      "area": "general",
      "job": "Search a list by name",
      "description": "Type in the \"Search...\" box in the bar below the header. On the Admin, Country and Company profile pages it filters the category cards or table rows to names that contain the text, upper and lower case do not matter, and the number at the right end of the bar shows how many match; on the HR page the box appears in the Employees view and finds employees by first and last name. \"Save Order\" is greyed out while a search is active.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "On the Company profile, the search is disabled until the selected company has benefit categories.",
      "aliases": [
        "search",
        "filter",
        "search box",
        "find a category",
        "look up by name",
        "filter the list",
        "find something on the page",
        "narrow down the list"
      ],
      "anchor": "subheader-search",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "GEN-009",
      "area": "general",
      "job": "Open the user manual",
      "description": "Click the book icon (\"User manual\") in the header, just before the \"?\" of the page guide. It lists the documents available to you, such as manuals and sign-up information; click one to open it in a new browser tab. For help with the screen you are on, use the \"?\" page guide.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "user manual",
        "manual",
        "documentation",
        "handbook",
        "download the manual",
        "PDF guide",
        "sign-up information",
        "instructions document"
      ],
      "source_ref": "src/components/HeaderDocumentLinks/HeaderDocumentLinks.tsx"
    },
    {
      "id": "IMP-001",
      "area": "implementations",
      "job": "Add an implementation to a benefit category",
      "description": "On Company profile, choose the country and the company, then click the + on the benefit category card (\"Add New Implementation\"); in list view use \"Implement Benefit\" in the category row. Inside the category (double-click its card picture or click \"Open Benefits\"), \"Add Benefit Implementation\" in the toolbar opens the same dialog. Fill in \"Name\", \"Consent Needed\", \"Is Auto Enrollment\", \"Currency\", \"Description\", the policy or insurer, \"Carrier\", \"Policy Number / Contract ID\", \"Valid From\" and \"Valid To\", then click \"Save\"; the new implementation appears as a card, ready for its packages.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin). The client already offers the benefit category; add it on Company profile with \"Add Benefit Category\" if it is missing.",
      "aliases": [
        "implement a benefit",
        "new implementation",
        "create an implementation",
        "add benefit implementation",
        "set up a benefit for a client",
        "add an insurer to a benefit",
        "add a policy to a benefit",
        "add a policy year",
        "set up insurance for a client"
      ],
      "anchor": "benefit-card-add",
      "source_ref": "help:CompanyProfilePage"
    },
    {
      "id": "IMP-002",
      "area": "implementations",
      "job": "Link an implementation to its policy and insurer",
      "description": "In the implementation dialog, type in \"Select Policy\" to search the client's policies in GrECo's records; picking one fills in \"Carrier\", \"Policy Number / Contract ID\" and the validity dates, so check them before saving. With no policy to pick, \"Select Insurer\" searches the insurers of the country and fills in the carrier, or you type the values yourself; \"Carrier\" (up to 254 characters) and \"Policy Number / Contract ID\" are required. To open the dialog, go to the category's implementations page (Company profile, then the benefit category card) and click \"Add Benefit Implementation\", or the edit icon on an implementation card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "select policy",
        "link a policy",
        "connect the policy to a benefit",
        "choose the insurer",
        "select insurer",
        "insurance company of a benefit",
        "policy number",
        "contract ID",
        "carrier",
        "insurance contract"
      ],
      "anchor": "implementation-dialog-policy",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "implementation-add",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-003",
      "area": "implementations",
      "job": "Require insurer consent before employees enroll",
      "description": "In the implementation dialog, set \"Consent Needed\" to Yes; this sets \"Is Auto Enrollment\" to No, and every enrollment into the implementation's packages then needs approval. Choose the \"Insurer Consent Type\": a link to the insurer's consent page (enter \"Consent Url\"), an insurer form (choose \"Consent Delivery Type\" and upload the \"Consent Document\" employees fill in), or a text to accept (write \"Consent text to be displayed\"), then click \"Save\". To open the dialog, go to the category's implementations page (Company profile, then the benefit category card) and click \"Add Benefit Implementation\", or the edit icon on an implementation card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "consent needed",
        "insurer consent",
        "consent form",
        "consent link",
        "consent url",
        "I agree text",
        "consent document",
        "employees must accept the insurer terms",
        "insurer consent type",
        "consent delivery type"
      ],
      "anchor": "implementation-dialog-consent-needed",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "implementation-add",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-004",
      "area": "implementations",
      "job": "Set the validity period of an implementation",
      "description": "On the category's implementations page (Company profile, then the benefit category card), click the edit icon on the implementation card, or \"Add Benefit Implementation\" for a new one, and enter \"Valid From\" and \"Valid To\" (day.month.year, or pick from the calendar). Both are required: \"Valid From\" may not be earlier than 1 January 2024, \"Valid To\" must be after it, and package eligibility dates are never calculated before \"Valid From\". For a new policy year, add a new implementation to the same category with the new dates and then add its packages there; two implementations of one category may share a name or policy number only if their validity periods do not overlap.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "valid from",
        "valid to",
        "validity dates",
        "policy period",
        "policy start date",
        "policy end date",
        "extend a policy",
        "renew a benefit",
        "new policy year",
        "renewal",
        "overlapping policy number"
      ],
      "anchor": "implementation-dialog-valid-from",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "benefit-card-edit",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-005",
      "area": "implementations",
      "job": "See expired or future implementations",
      "description": "On the category's implementations page, switch off \"Only Active\". While it is on, implementations whose validity period has not started yet or has already ended are hidden; switched off, past and future implementations are listed as well. The calendar tag on each card shows the validity from Valid From to Valid To. To get there, choose the country and the company on Company profile and open the benefit category (double-click its card picture or click \"Open Benefits\").",
      "roles": [
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Choose the country and the company on Company profile first.",
      "aliases": [
        "only active",
        "show inactive implementations",
        "implementation disappeared",
        "implementation is missing",
        "expired policy",
        "previous policy year",
        "future implementation",
        "show all implementations",
        "hidden implementations"
      ],
      "anchor": "only-active-switch",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-006",
      "area": "implementations",
      "job": "Edit an implementation",
      "description": "On the category's implementations page (Company profile, then the benefit category card), click the edit icon on the implementation card; the implementation dialog opens with the current consent rules, currency, policy and validity, and \"Save\" stores your changes. In list view (settings menu, gear icon in the header, \"View Mode\") you can instead change cells directly in the row and click Save in its Actions column, or Undo to go back; the pencil icon there opens the full dialog. Saving does not overwrite the implementation: the server keeps the previous version and stores a new one. If the server refuses the data, for example an overlapping name or policy number, an error message appears and your input stays.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "change an implementation",
        "update an implementation",
        "modify policy details",
        "change the currency",
        "wrong currency on an implementation",
        "fix an implementation",
        "change the carrier",
        "correct the policy number",
        "edit implementations in a table",
        "edit a benefit implementation"
      ],
      "anchor": "benefit-card-edit",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-007",
      "area": "implementations",
      "job": "Delete an implementation",
      "description": "On the category's implementations page (Company profile, then the benefit category card), click the red bin icon on the implementation card and confirm with \"Delete\"; in list view the delete icon is in the row's Actions column. This removes the implementation together with its documents, all its packages and their employee enrollments. The server carries out deletes only for GrECo global administrators.",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "SuperAdmin role: the card shows the bin icon only to SuperAdmin. The server carries out the delete only for GrECo global administrators.",
      "aliases": [
        "remove an implementation",
        "delete a benefit implementation",
        "remove a policy from a benefit",
        "delete a wrong implementation",
        "implementation created by mistake",
        "get rid of an implementation"
      ],
      "anchor": "benefit-card-delete",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-008",
      "area": "implementations",
      "job": "Add documents to an implementation",
      "description": "On the category's implementations page, click the documents icon (\"Manage Documents\") on the implementation card; in list view use \"Manage Documents\" or \"Add Documents\" in the Documents cell. In the documents dialog click \"Upload\" and choose files, use the eye icon to hide a file from employees, then save each file or click \"Save All\"; expand a saved document with its edit icon to add a summary or abstract, change \"Is Hidden For Employee\" and click \"Save Document\", or delete it with \"Remove Document\". Changes in this dialog are saved immediately. When you create a new implementation, \"Upload\" in its dialog attaches files that are saved together with it.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "implementation documents",
        "upload policy terms",
        "attach a file to an implementation",
        "attach a pdf to an implementation",
        "general terms of the policy",
        "add a policy document",
        "terms and conditions",
        "hide a document from employees",
        "remove an implementation document",
        "manage documents"
      ],
      "anchor": "benefit-card-documents",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "IMP-009",
      "area": "implementations",
      "job": "Open the packages of an implementation",
      "description": "On Company profile, choose the country and the company and open the benefit category (double-click its card picture or click \"Open Benefits\"). Then click \"Open Packages\" on the implementation card or double-click its picture; in list view use the open icon in the row's Actions column. The gift tag on the card shows how many packages the implementation has. HR users open the same packages from the \"Benefits\" view of the HR page.",
      "roles": [
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Choose the country and the company on Company profile first.",
      "aliases": [
        "where are the packages",
        "see the packages",
        "get to the packages of a benefit",
        "go to packages",
        "packages page",
        "view the plans of a benefit",
        "where are the plans of an insurer",
        "list the packages",
        "open benefit packages"
      ],
      "anchor": "benefit-card-open",
      "anchor_route": "/company-profile/:categoryId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyBenefitImplementationPage"
    },
    {
      "id": "PKG-001",
      "area": "packages",
      "job": "Add a package to an implementation",
      "description": "On Company profile, open the benefit category, click \"Open Packages\" on the implementation card and click \"Add Package\" in the toolbar; on the implementations page, the + on the implementation card (\"Add New Package\") or \"Add Package\" in a list-view row opens the same dialog. Fill in \"Name\", \"Carrier\", \"Premium/Cost\", \"Payment Method\", \"Value Type\", \"Paid by Company\" or \"Paid by Employee\", \"Payment Type\", \"Description\" and the eligibility, cancellation and offboarding rules, then click \"Save\". The currency comes from the implementation and cannot be changed in the package.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "The implementation exists. An admin role (global, country or company admin); for read-only and HR roles \"Add Package\" is disabled.",
      "aliases": [
        "new package",
        "create a package",
        "add a plan",
        "add a package option",
        "add a tier",
        "add another tier",
        "new benefit option",
        "set up a package",
        "add new package"
      ],
      "anchor": "packages-add",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-002",
      "area": "packages",
      "job": "Set a package's price and who pays which share",
      "description": "In the package dialog, enter the full price in \"Premium/Cost\", in the currency of the implementation. Choose \"Value Type\": with \"Percentage\" the \"Paid by Company\" and \"Paid by Employee\" shares must total 100, with \"Amount\" they must add up to exactly the premium. Typing one share fills the other with the remainder, so you normally fill in only one; if they do not add up, both fields show \"Payments must be equal to package price\" and the server refuses to save. Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card; in list view the same cells can be edited in the row.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "package price",
        "premium",
        "cost of a plan",
        "employer contribution",
        "employee contribution",
        "co-payment",
        "how much the employee pays",
        "company share",
        "percentage split",
        "value type",
        "payments must be equal to package price"
      ],
      "anchor": "package-dialog-price",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-003",
      "area": "packages",
      "job": "Choose how a package premium is paid",
      "description": "In the package dialog, pick the \"Payment Method\" from the list maintained in HBH, and the \"Payment Type\": direct payment, premium collection or salary deduction. Both are required. With salary deduction every enrollment into the package needs approval and the server refuses \"Is Auto Enrollment\"; employees get the client's \"Salary Deduction Consent\" document when they enroll in such a package in the employee app (it is uploaded in the client dialog on Company profile). Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "payment type",
        "payment method",
        "salary deduction",
        "payroll deduction",
        "direct payment",
        "premium collection",
        "how is the premium paid",
        "paid through salary"
      ],
      "anchor": "package-dialog-payment-type",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-004",
      "area": "packages",
      "job": "Limit a package to an age range",
      "description": "In the package dialog, enter \"Age Limit From\", \"Age Limit To\" or both; they are optional, and the range is shown next to the package name on the card. Employees or dependants outside the range cannot enroll themselves in the employee app, while enrollments entered by HR are not checked against it. Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "age limit",
        "minimum age",
        "maximum age",
        "age restriction",
        "age range",
        "children up to an age",
        "too old for a package",
        "children over 18 cannot join",
        "dependants above an age cannot join",
        "age limit from",
        "age limit to"
      ],
      "anchor": "package-dialog-age-from",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-005",
      "area": "packages",
      "job": "Set when employees become eligible for a package",
      "description": "In the package dialog, the start of eligibility has three parts: the reference date in \"Eligible From Date\" (start of employment or enrollment, start or end of policy, end of employment), the unit in \"Eligible From\" and the number of units in \"Eligible From Value\"; \"Immediate\" needs no value, and for a date in the next month the value is the day. The end works the same way with \"Eligible To Date\", \"Eligible To\" and \"Eligible To Value\", counted backwards when the reference is an end date. The calculated start is never before the policy start or the employment date, and an end after the policy end is cut back to the policy end.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "eligibility rules",
        "waiting period",
        "probation period",
        "eligible from",
        "eligible to",
        "eligibility start date",
        "when can employees join",
        "eligibility end",
        "eligibility date calculation"
      ],
      "anchor": "package-dialog-eligible-from",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-006",
      "area": "packages",
      "job": "Set from when employees can cancel a package",
      "description": "In the package dialog, \"Cancellation From Date\", \"Cancellation From\" and \"Cancellation Value\" give the earliest date an employee can cancel the package: a reference date, a unit and a number of units. With \"start of employment or enrollment\" the count starts at the enrollment date, and the result is never earlier than the eligibility date. Tick \"Requires Cancellation Approval\" if cancellations should wait for approval before they take effect; such packages show a red document icon on their card. Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "cancellation rules",
        "cancellation period",
        "minimum duration",
        "notice period",
        "lock-in period",
        "when can an employee cancel",
        "earliest cancellation date",
        "cannot cancel in the first year",
        "cancellation from",
        "cancellation approval"
      ],
      "anchor": "package-dialog-cancellation",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-007",
      "area": "packages",
      "job": "Set when cover ends after an employee leaves",
      "description": "In the package dialog, \"Offboarding From Date\", \"Offboarding From\" and \"Offboarding Value\" (a reference date, a unit and a number of units) calculate the offboarding date when an employee leaves the company. The result is never before the exit date and never after the policy end. Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card; in list view the rules appear as columns further right.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "offboarding",
        "offboarding date",
        "leaver",
        "end of employment",
        "cover after leaving",
        "employee leaves the company",
        "when does insurance stop after leaving",
        "exit date",
        "termination of employment"
      ],
      "anchor": "package-dialog-offboarding",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-008",
      "area": "packages",
      "job": "Choose auto-enrollment or approval for package enrollments",
      "description": "In the package dialog, tick \"Is Auto Enrollment\" to flag the package for auto-enrollment (green sync icon on the card), or \"Requires Enrollment Approval\" to make new enrollments wait for approval (green document icon with a check mark); ticking auto-enrollment clears the approval box. Auto-enrollment is disabled when the implementation needs consents and refused with payment type salary deduction; in both cases enrollments need approval anyway. New packages start with \"Is Auto Enrollment\" ticked when the implementation is set to auto-enrollment. Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "auto enrollment",
        "turn on auto enrollment",
        "auto enrol a package",
        "automatic enrollment",
        "enroll everyone automatically",
        "enrollment approval",
        "approve enrollments",
        "requires enrollment approval",
        "is auto enrollment",
        "enrollments must be approved"
      ],
      "anchor": "package-dialog-auto-enrollment",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-009",
      "area": "packages",
      "job": "Let employees upgrade to another package",
      "description": "In the package dialog, tick \"Is Upgradeable\". Employees can then enroll in this package while they already hold an active package of the same implementation, keeping their existing benefits during the move; if such an upgrade enrollment is rejected, the enrollment it replaced is restored. The card shows a green rocket icon. Open the dialog with \"Add Package\" on the packages page or the edit icon on a package card.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin).",
      "aliases": [
        "upgrade a package",
        "is upgradeable",
        "switch to a higher plan",
        "move to a better package",
        "change to a higher tier",
        "switch plans while enrolled",
        "from the basic plan to a better one",
        "two packages of the same benefit"
      ],
      "anchor": "package-dialog-upgradeable",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "anchor_surface": "packages-add",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-010",
      "area": "packages",
      "job": "Edit a package",
      "description": "On the implementation's packages page (Company profile, the benefit category, then \"Open Packages\" on the implementation card), click the edit icon on the package card, change the values in the package dialog and click \"Save\". In list view (settings menu, gear icon in the header, \"View Mode\") you can change most values directly in the row and click Save on that row, or Undo to restore the last saved values; the pencil icon opens the full dialog. Saving creates a new version of the package and the history is kept on the server; if a rule is broken (payment split, duplicate name), the server refuses and your changes stay.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin). Read-only and HR roles cannot change packages; HR asks the GrECo contact.",
      "aliases": [
        "change a package",
        "update a package",
        "modify a plan",
        "rename a package",
        "change the package price",
        "edit packages in a table",
        "correct a package",
        "update package details"
      ],
      "anchor": "benefit-card-edit",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-011",
      "area": "packages",
      "job": "Delete a package",
      "description": "On the implementation's packages page (Company profile, the benefit category, then \"Open Packages\" on the implementation card), click the red bin icon on the package card and confirm with \"Delete\"; in list view the delete icon is in the row's Actions column. This deletes the package together with its documents and all employee enrollments in it. The server carries out deletes only for GrECo global administrators.",
      "roles": [
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "SuperAdmin role: the card shows the bin icon only to SuperAdmin. The server carries out the delete only for GrECo global administrators.",
      "aliases": [
        "remove a package",
        "delete a plan",
        "remove a package option",
        "delete a wrong package",
        "package no longer offered",
        "package created by mistake",
        "get rid of a package"
      ],
      "anchor": "benefit-card-delete",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-012",
      "area": "packages",
      "job": "Add documents to a package",
      "description": "On the implementation's packages page, click the documents icon (\"Manage Documents\") on the package card; in list view use \"Manage Documents\" or \"Add Documents\" in the Documents cell. In the documents dialog click \"Upload\" and choose files, use the eye icon to hide a file from employees, then save each file or click \"Save All\"; expand a saved document with its edit icon to add a summary or abstract, change \"Is Hidden For Employee\" and click \"Save Document\", or delete it with \"Remove Document\". Changes in this dialog are saved immediately. When you create a new package, \"Upload\" in the package dialog attaches files that are saved together with it.",
      "roles": [
        "admin",
        "superadmin"
      ],
      "deeplink": "/company-profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "An admin role (global, country or company admin); the documents controls are disabled for read-only and HR roles.",
      "aliases": [
        "package documents",
        "package brochure",
        "upload a brochure",
        "attach terms to a plan",
        "package pdf",
        "hide a document from employees",
        "remove a package document",
        "manage documents"
      ],
      "anchor": "benefit-card-documents",
      "anchor_route": "/company-profile/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:CompanyPackagesPage"
    },
    {
      "id": "PKG-013",
      "area": "packages",
      "job": "See how many people are enrolled in each package",
      "description": "On the HR page, select the client, open the \"Benefits\" view and open the implementation with \"Open Packages\" on its card (or double-click the card picture). On the packages page, the person tag on each package card shows enrolled / eligible people for that package, employees and dependants together; hover it for the explanation. To see the people themselves, double-click the package's card picture (this works for every role) or click the people icon (\"Open Package Employees\") on the card.",
      "roles": [
        "hr",
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page.",
      "aliases": [
        "how many people are enrolled",
        "number of enrollments per package",
        "enrollment count",
        "enrolled versus eligible",
        "headcount per plan",
        "participation per package",
        "how many employees took the package"
      ],
      "anchor": "benefit-card-tags",
      "anchor_route": "/hr/packages/:categoryId/:implementationId/:countryCode/:clientInternalNumberGOS",
      "source_ref": "help:HrPackagesPage"
    },
    {
      "id": "PKG-014",
      "area": "packages",
      "job": "Check package prices and rules on the HR page",
      "description": "On the HR page, select the client, open the \"Benefits\" view and open an implementation with \"Open Packages\" on its card (or double-click the card picture; in list view use the open icon in the row). The packages page lists every package of that implementation; switch to list view in the settings menu (gear icon in the header) to see the premium, the company and employee shares and the eligibility, cancellation and offboarding rules as columns. HR roles see the packages read-only; ask your GrECo contact when a price, payment split or eligibility rule needs to change.",
      "roles": [
        "hr",
        "user",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page.",
      "aliases": [
        "HR packages",
        "view packages as HR",
        "see package prices",
        "see how much each package costs",
        "what does a package cost",
        "package price for employees",
        "who pays what",
        "plans of the client",
        "benefits view packages",
        "change a package price as HR"
      ],
      "anchor": "hr-benefits-list",
      "source_ref": "help:HrPackagesPage"
    },
    {
      "id": "RPT-001",
      "area": "reports",
      "job": "Download the current enrollments report",
      "description": "In the \"Employees\" view, open \"Actions\" in the toolbar and choose \"Employee Enrollments Report\". The Excel file has one row per employee or dependent with their currently active enrollments that are not waiting for approval, including premium, insurer and policy columns. For the enrollments of a date range with pro-rata premiums, choose \"Employee Enrollments Report by time period\" in the same menu.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" or \"Bulk Management\" view.",
      "aliases": [
        "enrollment report",
        "export enrollments",
        "download enrollments to excel",
        "excel list of enrolled employees",
        "premium report",
        "insurer report",
        "enrolment export",
        "who is enrolled report",
        "employee report"
      ],
      "anchor": "hr-enrollments-report",
      "anchor_surface": "hr-actions-menu",
      "source_ref": "help:HrPage"
    },
    {
      "id": "RPT-002",
      "area": "reports",
      "job": "Download enrollments for a time period",
      "description": "In the \"Employees\" view, open \"Actions\" in the toolbar and choose \"Employee Enrollments Report by time period\". Pick the \"From\" and \"To\" dates (both required) and click \"Generate\"; the Excel file downloads and lists the enrollments whose enrollment date falls in that period, with pro-rata premiums.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" or \"Bulk Management\" view.",
      "aliases": [
        "report for a period",
        "monthly enrollment report",
        "quarterly report",
        "enrollments between two dates",
        "pro-rata premiums",
        "new enrollments last month",
        "date range report",
        "report by time period"
      ],
      "anchor": "hr-enrollments-report-period",
      "anchor_surface": "hr-actions-menu",
      "source_ref": "help:HrPage"
    },
    {
      "id": "RPT-003",
      "area": "reports",
      "job": "Export employees' consents",
      "description": "For the signed consent documents, select employees in the \"Employees\" view and click \"Export Consents\" above the table (or the export icon in one employee's row), tick \"Is Salary Deduction Consent\" if you want the salary-deduction consents instead, and click \"Export\". The documents are zipped in the background and you receive an email with a download link; with \"Only Active\" on, only benefits running today are included. For an Excel overview of which consents each employee gave per enrollment, choose \"Actions\" › \"Export Consent Data\" instead.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client at the top of the HR page and open the \"Employees\" view. \"Export Consents\" stays disabled until you select employees.",
      "aliases": [
        "download consents",
        "consent documents",
        "GDPR consents",
        "signed consents",
        "salary deduction consent",
        "export consent forms",
        "consent report",
        "which consents were given",
        "consent status",
        "export consent data"
      ],
      "anchor": "hr-export-consents",
      "source_ref": "help:HrPage"
    },
    {
      "id": "RPT-004",
      "area": "reports",
      "job": "See headcount, enrollment counts and costs for a client",
      "description": "Select the client; the \"Summary\" view opens by default and shows \"Active Employees\", \"Active Dependents\", the enrollment counts (enrolled / total) and \"Company Costs\" and \"Employee Costs\". Narrow the figures with the period slider, the package tree and the currency and payment filters; \"Convert to\" shows the totals in another currency at the current exchange rates. Tick \"Historic report\" and pick a date to see the data as it stood on that day, then tick the packages again.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client in \"Select Company\" at the top of the HR page first.",
      "aliases": [
        "dashboard",
        "summary",
        "how many employees",
        "total costs",
        "company costs",
        "employee costs",
        "headcount",
        "number of enrollments",
        "cost overview",
        "historic report",
        "costs in another currency",
        "convert currency",
        "statistics",
        "monthly costs",
        "how much does the company pay",
        "total company cost"
      ],
      "anchor": "hr-tab-summary",
      "source_ref": "help:HrPage"
    },
    {
      "id": "RPT-005",
      "area": "reports",
      "job": "Open the Analytics report",
      "description": "Select the client at the top of the HR page and open the \"Analytics\" view; it shows the client's Power BI report embedded in the page, filtered to that client. Use the report's own filters and pages, and reload it with the refresh button at the top of the page.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client in \"Select Company\" at the top of the HR page first.",
      "aliases": [
        "power bi",
        "analytics",
        "charts",
        "power bi dashboard",
        "bi report",
        "graphs",
        "visual report",
        "embedded report"
      ],
      "anchor": "hr-tab-analytics",
      "source_ref": "help:HrPage"
    },
    {
      "id": "RPT-006",
      "area": "reports",
      "job": "Check past imports and bulk changes",
      "description": "Select the client and open the \"Action History\" view. Each row is one Excel import or bulk enrollment operation, with the user who started it and when it ran. \"Action Document\" opens the file the action worked on (for example the uploaded Excel file) and \"Report Document\" opens the result report, which lists the rows or people that were processed successfully and those that failed.",
      "roles": [
        "user",
        "hr",
        "admin",
        "superadmin"
      ],
      "deeplink": "/hr",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Select the client in \"Select Company\" at the top of the HR page first.",
      "aliases": [
        "action history",
        "import log",
        "import result",
        "did my import work",
        "who ran the import",
        "audit log",
        "history of bulk changes",
        "failed rows",
        "import errors",
        "activity log",
        "bulk result report",
        "check the result of an excel import"
      ],
      "anchor": "hr-tab-action-history",
      "source_ref": "help:HrPage"
    }
  ] as readonly CatalogEntry[];
